export var DateFormats;
(function (DateFormats) {
    DateFormats["UI_DISPLAY_LONG"] = "PPPP";
    DateFormats["UI_DISPLAY_SHORT"] = "dd LLL yyyy";
    DateFormats["CASUAL"] = "do LLL yy";
    /** Used in ajax date based queries */
    DateFormats["SIMPLE"] = "yyyy-MM-dd";
    DateFormats["UI_SHORT_TIME"] = "dd LLL yy p";
    DateFormats["UI_LONG_TIME"] = "MMMM dd, yyyy p";
    DateFormats["UI_LONG_TIME_TZ"] = "MMMM dd, yyyy p (z)";
})(DateFormats || (DateFormats = {}));
export const standardDateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
//# sourceMappingURL=dates.js.map